const VirtualCardTitle = ({ title, className }) => {
  return <div className={className}>{title}</div>;
};

export default VirtualCardTitle;
